module.exports = __webpack_public_path__ + "static/media/promo.9457f05e.png";